import { useLingui } from '@lingui/react/macro';
import { Textarea } from '@repo/videa-components/src/ui/textarea';
import { useAtomValue } from 'jotai';

import { clinicalNotesAtom } from '@/modules/claims/summary/state';

type ClinicalNoteProps = {
  clinicalNotesDraft: string;
  isEditing: boolean;
  onChange: (text: string) => void;
};

export const ClinicalNote = ({
  clinicalNotesDraft,
  isEditing,
  onChange,
}: ClinicalNoteProps) => {
  const clinicalNotes = useAtomValue(clinicalNotesAtom);

  const { t } = useLingui();

  if (isEditing) {
    return (
      <div className="vai-w-full vai-my-2 vai-py-1">
        <Textarea
          placeholder={t`Clinical Note`}
          value={clinicalNotesDraft}
          onChange={(e) => onChange(e.target.value)}
          autoResize
        />
      </div>
    );
  }

  return (
    <div
      className={`vai-w-full vai-text-sm vai-whitespace-pre-wrap vai-py-3 vai-px-3 vai-my-2 ${
        clinicalNotes ? '' : 'vai-text-gray-500'
      }`}
    >
      {clinicalNotes || t`No clinical note`}
    </div>
  );
};
